import { NotdPartnersModalComponent } from './../../shared/notd-partners-modal/notd-partners-modal.component';
import * as Debug from 'debug';
import { Component, ElementRef, Inject, OnDestroy, OnInit, PLATFORM_ID, ViewChild, AfterViewInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {isPlatformBrowser, Location} from '@angular/common';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

import {NoteService} from '../../shared/services/note_service';
import {Stream} from '../../shared/types/stream';
import { Team } from '../../shared/types/team';

import {StreamService} from '../../shared/services/stream_service';
import {UserService} from '../../shared/services/user_service';
import {Util} from '../../shared/util/util';
import {BankTransferComponent} from '../../user/bank-transfer/bank-transfer.component';
import {ConfirmationModalComponent} from '../../shared/confirmation-modal/confirmation-modal.component';
import {SocialSharingComponent} from '../../shared/social-sharing/social-sharing.component';
import {StreamKind} from '../../shared/types/stream_kind';

import {Title} from '@angular/platform-browser';

import {Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';

import {User} from '../../shared/types/user';

import { Note } from '../../shared/types/note';
import { SubscriptionPlansComponent } from '../../shared/subscribe-plans/subscribe-plans.component';
import { TeamService } from '../../shared/services/team_service';
import { GeoService } from '../../shared/services/geographic_service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { StreamCreatorModalComponent } from '../../shared/stream-creator-modal/stream-creator-modal.component';
import { StreamStatsModalComponent } from '../../shared/stream-stats-modal/stream-stats-modal.component';
import { GtmService } from '../../shared/services/gtm_service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ImageEditorComponent } from '../../shared/image-editor/image-editor.component';
import { SubscriptionStatus } from '../../shared/types/subscription_status';

const debug = Debug('notd:StreamDetails');

enum FollowStatus {
  owns = 1,
  following = 2,
  notfollowing = 3
}

export class BlockedUsersList {
  blockedUsers: any[];
  users: any[];
}

@Component({
  selector: 'app-stream-details',
  templateUrl: './stream-details.component.html',
  styleUrls: ['./stream-details.component.scss']
})

export class StreamDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(SubscriptionPlansComponent, {static: false}) public subscriptionPlans: SubscriptionPlansComponent;
  @ViewChild(SocialSharingComponent, {static: false}) public socialSharingComp: SocialSharingComponent;
  @ViewChild('followingModal', {static: false}) public followingModal: ElementRef;
  @ViewChild('blockedUsersListModal', {static: false}) public blockedUsersListModal: ElementRef;
  @ViewChild('streamMemebersModal', {static: false}) public streamMemebersModal: ElementRef;
  @ViewChild(StreamCreatorModalComponent, {static: false}) private streamCreatorModal: StreamCreatorModalComponent;
  @ViewChild(StreamStatsModalComponent, {static: false}) private streamStatsModal: StreamStatsModalComponent;
  @ViewChild(ImageEditorComponent, {static: false}) private imageEditorComponent: ImageEditorComponent;
  @ViewChild('notdPartnersModalCommunity', {static: false}) private partnersModal: NotdPartnersModalComponent;
  public isLoggedIn = false;
  user;

  notes: Note[];
  stream: Stream & {mainThumbnail: string};
  streamId: string;

  editingStream = false;
  isEditable = false;
  plansAreVisible = false;

  isStreamOwner = false;

  userIsFollowing: FollowStatus = FollowStatus.notfollowing;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  FollowStatus: typeof FollowStatus = FollowStatus;

  streamSubscription;
  selectedPeriod;
  balance;
  planStatusInfo;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  StreamKind: typeof StreamKind = StreamKind;
  iamAlreadyACommunityMember: boolean;
  communityObs$;
  loadingNotes = false;
  loadingButtonsStatus = true;
  notePageOffset = 0;
  notesPerPage = 10;
  public totalNumberNotes: number;
  pageChanged = new Subject<any>();
  noteListBoundaryLinks = true;
  loginScreenLoader = false;
  showPodcastIcon = false;
  subscriptionPlansPrice = {};
  searchInputProps = {};
  localQuerySearch: string;

  owner: User;
  public loadingShowMore = false;
  public subscriptionsStatus: any;
  public isMobile: boolean;
  public notificationStatus: boolean;
  public notUSCitizen = true;

  public blockedUsersList: BlockedUsersList;
  public blockedUsersModalMessage = {
    type: '',
    message: ''
  };

  public streamDescriptionLimited: string | null;

  public streamMemebers = {
    list: [],
    loading: false
  };

  public memberInviteForm: UntypedFormGroup;
  public sendInvitationLoading = false;
  public isUserTeamMember = false;
  public isUserAdmin = false;
  public isStreamFree = false;

  public streamThumb: {
    sizeLimit: number;
    limit: boolean;
    other: string | null;
    fileToUpload: any;
    localFile: any;
  } = {
    sizeLimit: 9146000,
    limit: false,
    other: '',
    fileToUpload: '',
    localFile: ''
  };

  public alert: {type: string; message: string; timeout?: number, floating?: boolean, gtmClass?: string};

  private routerEventsSubscription;
  private teamSubscriptionStatus: any;
  private streamSubscriptionStatus: any;
  private viewMode: string | null;
  private modalRef: any;

  constructor(
    private location: Location,
    protected userService: UserService,
    protected router: Router,
    protected route: ActivatedRoute,
    private noteService: NoteService,
    protected streamService: StreamService,
    private teamService: TeamService,
    private util: Util,
    private modalService: NgbModal,
    private geoService: GeoService,
    private gtmService: GtmService,
    private fb: UntypedFormBuilder,
    @Inject(PLATFORM_ID) private platformId: any,
    private titleService: Title
  ) {
    this.pageChanged
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe(model => this.getNotes());
  }

  public ngOnInit(): void {
    this.isLoggedIn = this.userService.isLoggedIn();
    this.selectedPeriod = 7;
    this.plansAreVisible = false;
    this.iamAlreadyACommunityMember = false;
    this.viewMode = this.route.snapshot.data.mode ? this.route.snapshot.data.mode : '';

    this.routerEventsSubscription = this.route.params.subscribe(params => {
      this.streamId = this.route.snapshot.data.requestedStream.id || params.id;
      this.checkForStreamStatusUpdate();

      this.gtmService.pushTag({
        event: 'show-stream-page',
        streamId: this.stream.id.toString() || this.streamId.toString(),
      });

      setTimeout(() => {
          this.loadingButtonsStatus = false;
      }, 2000);

      if (this.isLoggedIn && this.route.snapshot.queryParams['t']) {
        const urlToken = this.route.snapshot.queryParams['t'];
        const jwtHelper: JwtHelperService = new JwtHelperService();

        try {
          if (jwtHelper.decodeToken(urlToken)) {
            const decodedToken = jwtHelper.decodeToken(urlToken);

            this[decodedToken.meta.channelId ? 'streamService' : 'teamService']
              .validateSubscription(
                this.route.snapshot.queryParams['t'],
                decodedToken.meta.channelId ? decodedToken.meta.channelId : decodedToken.meta.teamId).then(validate => {
                  if (validate.status === SubscriptionStatus.Active ) {
                    this.checkForStreamStatusUpdate();
                    this.removeUrlParam();

                    this.setAlertMessage({
                      type: 'success',
                      message: `Your subscription has been activated.`,
                      timeout: 10000,
                      floating: false,
                      gtmClass: 'gtm_subsciption_thankyou'
                    });
                  } else {
                    this.showModalMessage(
                      'Error Confirming Payment.',
                      // eslint-disable-next-line max-len
                      'We encountered an issue while confirming your payment. Please try again or contact our customer service for assistance.');
                  }
            }, err => {
              console.error('Error while subscription validate', err.error || err);
            })
            .catch(err => {
              console.error('Error while subscription validate', err.error || err);
            });
          }
        } catch (err) {
          console.error('Looks like url doesn`t have proper token or it is a part of application url param.', err);
          // this.showModalMessage(
          //   'Error Confirming Payment.',
          //   'We encountered an issue while confirming your payment. Please try again or contact our customer service for assistance.');
        }
      }
    });

    this.streamSubscriptionStatus = this.streamService.getSubscriptionStatusUpdate().subscribe(res => {
      this.checkForStreamStatusUpdate();

      this.gtmService.pushTag({
        event: 'load-paid-content-stream-after-subscription',
        streamId: this.stream.id.toString(),
      });
    });

    this.teamSubscriptionStatus = this.teamService.subscriptionStatusUpdateSubject.subscribe(res => {
      this.checkForStreamStatusUpdate();

      this.gtmService.pushTag({
        event: 'load-paid-content-stream-after-team-subscription',
        streamId: this.stream.id.toString(),
      });
    });

    this.checkStreamPodcast();
    this.setNotesSearchProps();

    if (isPlatformBrowser(this.platformId)) {
      this.isMobile = this.util.isTouchDevice();
    }

    this.checkForUserTeamMembership().then(result => {
      this.isUserTeamMember = result;
    });

    this.isUserAdmin = !!this.user.admin;
  }

  public ngAfterViewInit(): void {
    if (this.viewMode) {
      switch(this.viewMode) {
        case 'profile':
          this.streamCreatorModal.showStreamModal();
          break;
        case 'subscription/settings':
          this.streamCreatorModal.showStreamModal();

          if (isPlatformBrowser(this.platformId)) {
            const moodalSubscriptionSectionSelector = document.querySelectorAll('.stream-creator-modal__form')[3];
            setTimeout(() => {
              moodalSubscriptionSectionSelector.scrollIntoView({
                block: 'center'
              });
            }, 300);
          }

          break;
      }
    }
  }

  public configureStream(): void {
    this.user = this.route.snapshot.data.user;
    let userId = 0;

    if (this.user) {
      userId = this.user.id;
      if (this.user.funds && this.user.funds.PROD) {
        let balance: any = '' + this.user.funds.PROD; // Balance is stored in 1/10000 USD
        balance = parseFloat(balance.substr(0, balance.length - 2)) / 100; // We truncate value, not round it
        this.balance = balance;
      }
    }

    const requestedStream = this.route.snapshot.data.requestedStream;

    debug('configureStream requestedStream', requestedStream);
    if (!requestedStream) {
      return;
    }

    this.stream = requestedStream;
    // this.isStreamFree = (requestedStream.kind === StreamKind['Free']) ? true : false;
    this.stream.mainThumbnail = this.stream.iconImageThbs ? this.getThumb(this.stream.iconImageThbs) : '';

    this.setStreamOwner(this.stream.userId);

    if (userId === requestedStream.userId) {
      this.configEditableForm();
      this.isStreamOwner = true;
    } else {
      if (this.isLoggedIn) {
        this.communityObs$ = this.userService.listCommunities().subscribe(comList => {
            if (comList.length > 0) {
                const resp = comList.filter(s => s.id === this.stream.id);
                this.iamAlreadyACommunityMember = resp.length > 0;
            }
          },
          (err) => {
            console.error('Error while fetching lost of communities', err);
          }
        );
      }

      this.isStreamOwner = false;
      this.isEditable = false;
      this.editingStream = false;

      if (this.isLoggedIn) {
        this.userIsFollowing = FollowStatus.notfollowing;
        this.streamService.getFollowedStreamsObservable().subscribe((streams: Stream[]) => {
          if (streams && streams.length) {
            for (const stream of streams) {
              if (stream && stream.id === this.streamId) {
                this.userIsFollowing = FollowStatus.following;
                this.notificationStatus = true;
              }
            }
          }
        });
      }
    }

    if (this.stream.iconImageUrl) {
      this.stream.iconImageUrl = this.util.uncacheUrl(this.stream.iconImageUrl);
    }

    if (this.stream.description.length > 100) {
      this.streamDescriptionLimited = this.reduceText(this.stream.description, 125);
    }

    if (this.isStreamOwner) {
      this.getBlockedUsersList();
    }
  }

  public showMoreNotes(ev: Event): void {
    this.notePageOffset = this.notePageOffset + 1;
    this.getNotes();
  }

  public followStream(): void {
    this.streamService.followStream(this.streamId).then(() => {
      this.userIsFollowing = FollowStatus.following;
    }).catch(ex => console.error('Error updating following stream ', ex));
  }

  public unFollowStream(): void {
    this.streamService.unFollowStream(this.streamId).then(() => {
      this.userIsFollowing = FollowStatus.notfollowing;
    }).catch(ex => console.error('Error updating following stream ', ex));
  }

  public deleteStream(): void {
    const modalOptions: NgbModalOptions = {};

    modalOptions.size = 'lg';

    const refModalConf = this.modalService.open(ConfirmationModalComponent, modalOptions);

    refModalConf.componentInstance.confirmationModalTitle = 'You are about to DELETE a stream';
    refModalConf.componentInstance.confirmationModalMsg = 'This stream and all of its notes will be DELETED. Do you want to continue?';
    refModalConf.result.then(resp => {
      if (resp === true) { // DELETE STREAM
        modalOptions.backdrop = 'static'; // Prevents closing from clicking outside
        modalOptions.keyboard = false; // Prevents closing from pressing ESC

        const refModalConf2 = this.modalService.open(ConfirmationModalComponent, modalOptions);
        refModalConf2.componentInstance.onlyMessage = true;
        refModalConf2.componentInstance.confirmationModalTitle = 'Deleting the stream';
        refModalConf2.componentInstance.waiting = true;
        refModalConf2.componentInstance.confirmationModalMsg = '';

        this.streamService.deleteStream(this.streamId).then(
          () => {
            refModalConf2.componentInstance.confirmationModalTitle = 'You have DELETED the stream';
            refModalConf2.componentInstance.confirmationModalMsg = 'This stream has been DELETED';
            refModalConf2.componentInstance.waiting = false;

            refModalConf2.result.then(() => {
              this.router.navigate(['/user', this.user.id, 'profile', (this.user.displayName || 'user')]);
            });
          },
          err => {
            console.error('Error', err);
            refModalConf2.componentInstance.confirmationModalTitle = 'Stream couldn´t be deleted';
            refModalConf2.componentInstance.confirmationModalMsg = err.toString();
            refModalConf2.componentInstance.waiting = false;
          }
        );
      }
    }).catch(err => {
      // Cross click
    });
  }

  public openStreamModal(): void {
    this.streamCreatorModal.showStreamModal();
  }

  public showStreamStatsModal(): void {
    this.streamStatsModal.showModal();
  }

  public cancelStreamInfo(data): void {
    this.stream.name = data.name;
    this.stream.description = data.description;
  }

  public streamSavedUpdate(ev: any): void {
    this.stream.description = ev.description;
    delete this.streamDescriptionLimited;
    this.stream.name = ev.name;
  }

  public closeStreamCreatorModal(): void {
    delete this.streamDescriptionLimited;
  }

  closeStreamEdition() {
    this.editingStream = false;
    this.plansAreVisible = false;
  }

  openSubscriptions(open = true) {
    if (!this.isEditable && this.stream.kind === StreamKind.OpenCommunity && !this.iamAlreadyACommunityMember) {
      this.showConfirmationModal('Community stream', 'Before subscription you need to Join community stream.');
    } else {
      this.plansAreVisible = open;
    }
  }

  planStatusEvent(info) {
    console.log('planStatusEvent', info, info !== undefined);
    this.planStatusInfo = info;
  }

  subscriptionStatusUpdateEvent(plan) {
    console.log('subscriptionStatusUpdateEvent: ', plan);
  }

  transferToBank() {
    const modalOptions: NgbModalOptions = {};

    modalOptions.size = 'lg';
    modalOptions.backdrop = 'static'; // Prevents closing from clicking outside
    modalOptions.keyboard = false; // Prevents closing from pressing ESC

    const refModalConf = this.modalService.open(BankTransferComponent, modalOptions);

    refModalConf.result.then(resp => {
      this.balance = resp;
    }).catch(err => {
      console.error('Error while closing modal', err);
    });
  }

  joinOpenCommunity() {
    this.streamService.joinOpenCommunity(this.streamId).then(
      () => {
        this.showConfirmationModal('Welcome', 'You have joined ' + this.stream.name);
        this.iamAlreadyACommunityMember = true;
        this.streamService.joinedCommunitySub.next(true);
      },
      err => {
        if (err.code) {
          switch (err.code) {
            case 'ALREADY_EXISTS':
              this.showConfirmationModal('Error', 'You have already joined ' + this.stream.name);
              break;
            default:
          }
        }
      }
    );
  }

  public signin(): void {
    this.partnersModal.showModal();
  }

  showConfirmationModal(title: string, message: string) {
    const modalOptions: NgbModalOptions = {};
    const refModalConf = this.modalService.open(ConfirmationModalComponent, modalOptions);

    refModalConf.componentInstance.onlyMessage = true;
    refModalConf.componentInstance.confirmationModalTitle = title;
    refModalConf.componentInstance.confirmationModalMsg = message;
  }

  public noteDeletedEvent(): void {
    this.notes = [];
    this.notePageOffset = 0;
    this.getNotes({timeout: 3000});
  }

  noteListPageChange(page: number) {
    this.pageChanged.next(page);
  }

  setStreamOwner(userId) {
    this.userService.getUserProfile(userId)
      .then((user: User) => {
        this.owner = user;
      })
      .catch((err) => {
        console.log('error retrieving stream owner', err);
      });
  }

  openSocialModal() {
    this.socialSharingComp.openModal();
  }

  checkStreamPodcast() {
    if (this.stream && this.stream['postTags']) {
      this.showPodcastIcon = this.stream['postTags'].filter(t => t === 'type-audio' || t === 'kind-audio').length ? true : false;
    } else {
      this.showPodcastIcon = false;
    }
  }

  setNotesSearchProps() {
    this.searchInputProps = {
      showButton: true,
      buttonText: 'Search',
      customClass: 'notes-search',
      inputPlaceholder: 'Search for content'
    };
  }

  getSearchInputValue(ev: any) {
    this.notes = [];
    this.localQuerySearch = ev;
    this.notePageOffset = 1;
    this.getNotes();
  }

  public openSubscribePlansModal(): void {
    this.subscriptionPlans.showSubscriptionsModal();
  }

  public subscriptionPlansStatus(status: any): void {
    this.subscriptionsStatus = status;
  }

  public showFollowingModal(): void {
    this.modalRef = this.modalService.open(this.followingModal, {
      windowClass: 'following-modal'
    });
  }

  public selectNotificationStatus(status: boolean): void {
    this.notificationStatus = status;
  }

  public updateStreamNotifications(): void {
    if (this.notificationStatus) {
      this.followStream();
    } else {
      this.unFollowStream();
    }

    this.modalRef.close();
  }

  public partnersModalClosed(): void {
    this.loginScreenLoader = false;
  }

  public ngOnDestroy(): void {
    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }

    if (this.communityObs$) {
      this.communityObs$.unsubscribe();
    }

    if (this.pageChanged) {
      this.pageChanged.unsubscribe();
    }

    if (this.teamSubscriptionStatus) {
      this.teamSubscriptionStatus.unsubscribe();
    }

    if (this.streamSubscriptionStatus) {
      this.streamSubscriptionStatus.unsubscribe();
    }
  }

  public showBlockedUsersListModal(): void {
    const modalRef = this.modalService.open(this.blockedUsersListModal, {
      windowClass: 'blocked-users-modal',
      size: 'lg'
    });

    modalRef.result.then(result => {
      console.log(`Closed with:`, result);
      this.blockedUsersModalMessage = {
        type: '',
        message: ''
      };
    }, reason => {
      console.log(`Dismissed`, reason);
      this.blockedUsersModalMessage = {
        type: '',
        message: ''
      };
    });
  }

  public getBlockedUsersList(): void {
    this.userService.getBlockedUsers(this.streamId).then((users: BlockedUsersList) => {
      const blockedList = users;

      for (const u of blockedList.blockedUsers) {
        u.user = blockedList.users[u.userId] || {};
      }

      this.blockedUsersList = users;
    });
  }

  public unblockUser(u: any): void {
    this.userService.removeBlockedUser(this.streamId, u.userId).then(() => {
      this.blockedUsersModalMessage = {
        type: 'success',
        message: `${u.user.displayName || u.user.userNameDisp} has been succesfully unblocked.`
      };

      this.getBlockedUsersList();
    }, err => {
      console.error('Error while unblocking user', err);
      this.blockedUsersModalMessage = {
        type: 'error',
        message: 'There was an error while unblocking this user.'
      };
    });
  }

  public showStreamMembersModal(): void {
    const modalRef = this.modalService.open(this.streamMemebersModal, {
      windowClass: 'stream-members-modal',
      size: 'lg'
    });

    this.alert = {
      type: '',
      message: '',
      timeout: 0
    };
    this.createInviteMemberForm();
    this.getCommmunityMembersList();

    modalRef.result.then(result => {
      console.log(`Closed with:`, result);
      this.streamMemebers = {
        list: [],
        loading: false
      };
    }, reason => {
      console.log(`Dismissed`, reason);
      this.streamMemebers = {
        list: [],
        loading: false
      };
    });
  }

  public removeUser(member: any): void {
    const modalOptions: NgbModalOptions = {};
    const refModalConf = this.modalService.open(ConfirmationModalComponent, modalOptions);

    refModalConf.componentInstance.confirmationModalTitle = 'Remove user from members list';
    refModalConf.componentInstance.confirmationModalMsg = 'Do you want to remove this user from the community member list?';

    refModalConf.result.then(resp => {
        if (resp) {
          this.streamService.removeCommunityMember(this.streamId, member.userId).then(res => {
            this.setAlertMessage({
              type: 'success',
              message: `User has been removed from community members list.`,
              timeout: 10000,
              floating: false
            });

            this.getCommmunityMembersList();
          });
        } else {
          return false;
        }
    })
    .catch(err => {
      console.log(err);
    });
  }

  public sendMemberInvitation(): void {
    this.validateAllFormFields(this.memberInviteForm);
    if (this.memberInviteForm.valid) {
      const memberEmail = this.memberInviteForm.get('email').value;
      this.sendInvitationLoading = true;

      this.streamService.inviteToCommunity(this.streamId, memberEmail).then(resp => {
        this.setAlertMessage({
          type: 'success',
          message: `Invitation has been sent to the e-mail owner.`,
          timeout: 10000,
          floating: false
        });

        this.sendInvitationLoading = false;
        this.getCommmunityMembersList();
      }, err => {
        console.error('inviteToCommunity api error', err);

        const errorCode = (err.error && err.error.code) ? err.error.code : null;
        let message: string;

        switch (errorCode) {
          case 'ALREADY_EXISTS':
            message = 'This user is already a member. Please try to add different e-mail.';
            break;
          case 'DOES_NOT_EXIST':
            message = 'This user doesn`t exist.';
            break;
          default:
            message = err.error.message || 'There was an unexpected error. Please try again.';
            break;
        }

        this.setAlertMessage({
          type: 'error',
          message,
          timeout: 10000,
          floating: false
        });

        this.sendInvitationLoading = false;
      });
    }
  }

  public showThumbModal(): void {
    this.imageEditorComponent.editImageModal();
  }

  public setStreamThumbnail(e: any): void {
    this.streamThumb.limit = false;
    this.streamThumb.other = '';

    const newImg = e['dataURL'];
    const imgSize = newImg.replace(/=/g, '').length * 0.75;

    if (imgSize > this.streamThumb.sizeLimit) {
      this.streamThumb.limit = true;
    } else {
      fetch(newImg)
        .then(res => res.blob())
        .then(blob => {
          const fileName = e.name ? e.name : `${new Date().getTime()}.${blob.type.split('/')[1]}`;
          const f = new File([blob], fileName, {type: blob.type});

          this.util.downscaleImage(f, 1146000).then(downscaledImg => {
            this.streamThumb.fileToUpload = downscaledImg;
            this.uploadThumbnail(this.streamThumb.fileToUpload, this.stream.id);
          }, err => {
            this.streamThumb.fileToUpload = f;
            this.uploadThumbnail(this.streamThumb.fileToUpload, this.stream.id);
          });
        });

      this.streamThumb.localFile = newImg;
    }
  }

  private uploadThumbnail(fileToUpload: any, streamId: string | number): void {
    this.streamService.uploadThumbnail(fileToUpload, streamId.toString()).then(result => {
      if (result.code && result.message) {
        this.showModalMessage('Error while uplaoding Thumbnail', result.message);
      } else {
        Object.assign(this.stream, {
          iconImage: result.iconImage,
          iconImageThbs: result.iconImageThbs,
          iconImageUrl: result.iconImageUrl,
          iconImgMeta: result.iconImgMeta,
        });
      }
    }, err => {
      const errorMessage = 'There was an error while uploading your thumbnail, please try again!';
      console.error(errorMessage, err);
    });
  }

  private createInviteMemberForm(): void {
    this.memberInviteForm = this.fb.group({
      email: [null, [
        Validators.required,
        Validators.email]
      ]
    }, {updateOn: 'submit'});

    this.memberInviteForm.markAsUntouched();
  }

  private getCommmunityMembersList(): void {
    this.streamMemebers.list = null;
    this.streamMemebers.loading = true;
    this.streamService.getStreamMembers(this.stream.id).then(members => {
      if (members && members.length) {
        const membersProfilesApis = [];

        for (const u of members) {
          membersProfilesApis.push(this.userService.getUserProfile(u.userId));
        }

        Promise.all(membersProfilesApis).then(users => {
          for (const m of members) {
            const userMatch = users.filter(u => u.id === m.userId);

            if (userMatch && userMatch[0]) {
              m.user = userMatch[0];
            }
          }

          this.streamMemebers.list = members;
          this.streamMemebers.loading = false;
        });
      } else {
        this.streamMemebers.list = [];
        this.streamMemebers.loading = false;
      }
    }, err => {
      console.error('Error fetching stream members', err);
    });
  }

  private setAlertMessage(options: {type: string, message: string, timeout?: number, floating?: boolean, gtmClass?: string}): void {
    this.alert = {
      type: options.type,
      message: options.message,
      timeout: options.timeout ?? 5000,
      floating: options.floating ?? false,
      gtmClass: options.gtmClass ?? ''
    };
  }

  private checkForStreamStatusUpdate(): void {
    this.plansAreVisible = false;
    this.editingStream = false;
    this.planStatusInfo = null;
    this.notePageOffset = 0;
    this.getNotes();
    this.configureStream();
    this.getSubscriptionPlans();
  }

  private reduceText(text: string, limit: number): string {
    return text.split(' ').slice(0, limit).join(' ')  + '...';
  }

  private getNotes(delay?: {timeout: number}): void {
    if (!this.notePageOffset ||  this.notePageOffset === 0) {
      this.notes = [];
      this.loadingNotes = true;
    } else {
      this.loadingShowMore = true;
    }

    const notesQuery = {
      sort: 'createdDateDesc',
      queryString: this.localQuerySearch ? this.localQuerySearch : '',
      size: this.notesPerPage,
      fromOffset: this.notePageOffset * this.notesPerPage
    };

    setTimeout(() => {
      this.streamService.getStreamNotes(this.streamId, notesQuery)
        .then((notes: {posts: Note[]; total: number}) => {
          if (delay) {
            setTimeout(() => {
              console.log('delay on', delay.timeout);
            }, delay.timeout);
          }
        this.loadingShowMore = false;
  
        if (notes['posts']) {
          const orderedNotes = notes['posts'];
          this.totalNumberNotes = notes.total || 0;
  
          const usersIdArray = [];
          for (const note of orderedNotes) {
            if (note.userId) {
              usersIdArray.push(note.userId);
            }
          }
  
          const userIdArray = usersIdArray.filter((v, i) => usersIdArray.indexOf(v) === i);
          const userObjectArray = [];
          for (const userId of userIdArray) {
            userObjectArray.push(this.userService.getUserProfile(userId));
          }
  
          if (userObjectArray.length) {
            Promise.all(userObjectArray).then(results => {
              const usersResult = results;
  
              for (const note of orderedNotes) {
                for (const user of usersResult) {
                  if (user && user.id === note.userId) {
                    note.user = user;
                  }
                }
  
                this.notes.push(note);
              }
  
              this.loadingNotes = false;
            });
          }
  
          this.loadingNotes = false;
        }
      })
      .catch(err => {
        this.loadingNotes = false;
        this.loadingShowMore = false;
        console.error('Error while fetching stream notes', err);
      });
    }, delay && delay.timeout ? delay.timeout : 0);
  }

  private getThumb(thumbQualityArray: any): string {
    let maxQ = 0;
    let bestThumb: any;

    for (const [key, value] of Object.entries(thumbQualityArray)) {
      const keyV = parseInt(key, 10);
      if (maxQ < keyV) {
        maxQ = keyV;
        bestThumb = value;
      }
    }

    return bestThumb;
  }

  private getMinMaxSubscriptionPrice(dataObject: any, prop: string) {
    return dataObject.reduce((result, obj) => {
      if (obj[prop] < result.min) {
        result.min = obj[prop];
      }
      if (obj[prop] > result.max) {
        result.max = obj[prop];
      }
      return result;
    }, {min: Number.MAX_VALUE, max: Number.MIN_VALUE});
  }

  private configEditableForm() {
    this.isEditable = true;
    this.userIsFollowing = FollowStatus.owns;
  }

  private getSubscriptionPlans(): void {
    Promise.all([
      this.streamService.getStreamSubscriptionPlans(this.streamId),
      this.geoService.getCurrentLocation(false)
    ]).then(([plans, location]) => {
      const loc: any = location;
      this.notUSCitizen = loc && loc.country && loc.country !== 'US';

      const plansMinMaxPrices = this.getMinMaxSubscriptionPrice(plans, 'price');
      this.subscriptionPlansPrice = {
        min: plansMinMaxPrices['min'],
        max: plansMinMaxPrices['max']
      };

      this.isStreamFree = (plansMinMaxPrices['min'] === 0) || (this.route.snapshot.data.requestedStream.kind === StreamKind['Free']);
    });
  }

  private checkForUserTeamMembership(): Promise<boolean> {
    return this.streamService.getStreamTeam(this.stream.id).then((teams: Team[]) => {
      for (const t of teams) {
        const teamMembers = t.members;
        if (teamMembers[this.user.id]) {
          return true;
        }
      }
    });
  }

  private showModalMessage(title: string, message: string): void {
    const modalOptions: NgbModalOptions = {};
    const refModalConf = this.modalService.open(ConfirmationModalComponent, modalOptions);

    refModalConf.componentInstance.onlyMessage = true;
    refModalConf.componentInstance.confirmationModalTitle = title;
    refModalConf.componentInstance.confirmationModalMsg = message;

    refModalConf.result.then(resp => {
      if (resp) {
        console.log(resp);
      }
    })
    .catch(err => {
      console.log(err);
    });
  }

  private removeUrlParam(): void {
    const newUrl = window.location.pathname;
    this.location.replaceState(newUrl);
  }

  private validateAllFormFields(formGroup: UntypedFormGroup): void {
    Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (control instanceof UntypedFormControl) {
            control.markAsTouched({ onlySelf: true });
        } else if (control instanceof UntypedFormGroup) {
            this.validateAllFormFields(control);
        }
    });
  }
}
